import React from 'react';
import PropTypes from 'prop-types';

export default function ErrorMessage ({ errorText, className }) {
  return errorText ? <div className={`validation-error ${className || ''}`}>{errorText}</div> : null;
}

ErrorMessage.propTypes = {
  errorText: PropTypes.string,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/common/forms/ErrorMessage.js